module.exports = __webpack_public_path__ + "img/bulk-action-icon.66ce7ec0.svg";